export function efTrack (offerId, eventId) {
  /* eslint-disable no-undef */
  EF.conversion({
      offer_id: offerId,
      adv_event_id: eventId,
    });
  console.log('EF',{
    offer_id: offerId,
    adv_event_id: eventId,
  });
  /* eslint-enable no-undef */
}